import React from 'react';
import { ExamineText } from '../utils/ExamineFlavorText';

interface ExamineModalProps {
  examineData: ExamineText | null;
  onClose: () => void;
}

export const ExamineModal: React.FC<ExamineModalProps> = ({ examineData, onClose }) => {
  if (!examineData) return null;

  const handleCopyIslandId = (): void => {
    if (!examineData.islandId) return;
    void navigator.clipboard?.writeText(examineData.islandId);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10002,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'linear-gradient(180deg, #0d1117 0%, #0a0e14 100%)',
          border: '2px solid #21262d',
          boxShadow: '0 0 0 1px #161b22, 0 20px 50px rgba(0, 0, 0, 0.8)',
          padding: '0',
          maxWidth: '500px',
          width: '90%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            padding: '16px 20px',
            borderBottom: '2px solid #21262d',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: '18px',
              color: '#e2e8f0',
              fontWeight: 600,
            }}
            className="font-seurat"
          >
            {examineData.title}
          </h2>
          <button
            style={{
              background: 'none',
              border: 'none',
              color: '#8b949e',
              fontSize: '24px',
              cursor: 'pointer',
              padding: '0',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: 1,
            }}
            onClick={onClose}
            title="Close"
          >
            ×
          </button>
        </div>
        <div
          style={{
            padding: '20px',
            fontSize: '14px',
            color: '#c9d1d9',
            lineHeight: '1.6',
          }}
          className="font-seurat"
        >
          {examineData.description}
          {examineData.islandId && (
            <div
              style={{
                marginTop: '12px',
                fontSize: '12px',
                color: '#8b949e',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
              className="font-seurat"
            >
              <span>Island ID: {examineData.islandId}</span>
              <button
                style={{
                  backgroundColor: '#21262d',
                  color: '#c9d1d9',
                  border: '1px solid #30363d',
                  borderRadius: '6px',
                  padding: '2px 8px',
                  fontSize: '11px',
                  cursor: 'pointer',
                  fontFamily: 'var(--font-mono)',
                }}
                className="font-seurat"
                onClick={handleCopyIslandId}
                title="Copy island ID"
              >
                Copy
              </button>
            </div>
          )}
        </div>
        <div
          style={{
            padding: '12px 20px',
            borderTop: '1px solid #21262d',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <button
            style={{
              backgroundColor: '#238636',
              color: '#ffffff',
              border: 'none',
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: 'var(--font-mono)',
            }}
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
